<template>
	<right-panel :datas="connects" ref="rightPanel" @onClose="onClose">
		<div slot="header">
			<translate>Advanced Search</translate>
		</div>
		<div slot="content" class="wrapper-padding">
			<el-form :model="advanceSearchForm" ref="advanceSearchForm" label-width="100px" class="demo-ruleForm">
				<el-form-item :label="attrText.resourceType" prop="resourceType">
					<el-select v-model="advanceSearchForm.resourceType">
						<el-option :label="attrText.select" value=""></el-option>
						<el-option label="Linux（SSH）" value="Linux"></el-option>
						<el-option label="Windows（RDP）" value="Windows"></el-option>
						<el-option label="MySQL" value="MySQL"></el-option>
						<el-option label="SQL Server" value="SQL Server"></el-option>
						<el-option label="PostgreSQL" value="postgresql"></el-option>
						<el-option label="Oracle" value="oracle"></el-option>
						<el-option :label=attrText.fileTransfer value="transfer"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="attrText.command" prop="keywords">
					<el-input v-model.trim="advanceSearchForm.keywords"></el-input>
				</el-form-item>
				<el-form-item :label="attrText.member" prop="member">
					<div class="auto-search">
						<el-autocomplete popper-class="my-autocomplete" v-model.trim="advanceSearchForm.member" :fetch-suggestions="memberSearch" custom-item="allMember" :trigger-on-focus="false" :placeholder="attrText.pleaseinput" @select="memberSelect"> </el-autocomplete>
					</div>
				</el-form-item>
				<el-form-item :label="attrText.ip" prop="ip">
					<div class="auto-search">
						<el-input v-model.trim="advanceSearchForm.ip" placeholder="例：192.168.1.1"> </el-input>
					</div>
				</el-form-item>
				<el-form-item :label="attrText.resourceName" prop="resourceName">
					<div class="auto-search">
						<el-autocomplete popper-class="my-autocomplete" v-model.trim="advanceSearchForm.resourceName" custom-item="allResourceName" :fetch-suggestions="resourceNameSearch" :placeholder="attrText.pleaseinput" :trigger-on-focus="false" @select="resourceSelect"> </el-autocomplete>
					</div>
				</el-form-item>
				<el-form-item :label="attrText.time" prop="timeType">
					<el-radio-group v-model="advanceSearchForm.timeType">
						<el-form-item prop="timeRange">
							<el-radio label="1">
								<el-select v-model="advanceSearchForm.timeRange" :disabled="advanceSearchForm.timeType !== '1'">
									<el-option :label="attrText.unlimited" value="unlimit"></el-option>
									<el-option :label="attrText.oneDay" value="oneDay"></el-option>
									<el-option :label="attrText.sevenDay" value="sevenDay"></el-option>
									<el-option :label="attrText.oneMouth" value="oneMouth"></el-option>
								</el-select>
							</el-radio>
						</el-form-item>
						<el-form-item prop="startTime">
							<div class="radio-search">
								<el-radio label="2">
									<el-date-picker type="date" :placeholder="attrText.startTime" v-model="advanceSearchForm.startTime" style="width: 130px" :disabled="advanceSearchForm.timeType !== '2'" prop="startTime"></el-date-picker>
									<span><translate>To</translate></span>
									<el-date-picker type="date" :placeholder="attrText.endTime" v-model="advanceSearchForm.endTime" style="width: 130px" :disabled="advanceSearchForm.timeType !== '2'" prop="endTime"></el-date-picker>
								</el-radio>
							</div>
						</el-form-item>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="unSafeMode">
					<el-checkbox v-model="advanceSearchForm.unSafeMode" prop="unSafeMode">
						<translate>Non-Security Mode Connection</translate>
					</el-checkbox>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="detail-btn">
			<el-button type="primary" @click="onSubmitSearch(advanceSearchForm)">
				<translate>Search</translate>
			</el-button>
			<el-button @click="resetForm('advanceSearchForm')">
				<translate>Reset</translate>
			</el-button>
		</div>
	</right-panel>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import { Utils, baseUrl } from '../../../config'
import moment from '../../../../node_modules/moment/src/moment'
import Vue from 'vue'
// 自定义搜索提示 成员提示
Vue.component('allMember', {
	functional: true,
	render: function (h, ctx) {
		let item = ctx.props.item
		return h('li', ctx.data, [h('img', { attrs: { class: 'avatar', src: item.avatar ? `${baseUrl}${item.avatar}` : '../../../static/images/avatar.png' } }), h('span', { attrs: { class: 'name' } }, [item.name])])
	},
	props: {
		item: { type: Object, required: true },
	},
})
// 资源名称提示
Vue.component('allResourceName', {
	functional: true,
	render: function (h, ctx) {
		let item = ctx.props.item
		return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item])])
	},
	props: {
		item: { type: String, required: true },
	},
})
export default {
	name: 'LogSearch',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			tag: [],
			advanceSearchForm: {
				resourceType: '',
				keywords: '',
				member: '',
				ip: '',
				resourceName: '',
				timeType: '1',
				timeRange: 'unlimit',
				startTime: '',
				endTime: '',
				unSafeMode: false,
				allMember: [],
				allResourceName: [],
			},
		}
	},
	computed: {
		attrText() {
			return this.initTranslateText()
		},
	},
	created() {
		this.getMemberName()
		this.getAllResourceName()
	},
	methods: {
		// 提取翻译文本
		initTranslateText() {
			return {
				resourceName: this.$gettext('Resource Name'),
				command: this.$gettext('Command'),
				member: this.$gettext('Member'),
				resourceType: this.$gettext('Resource Type'),
				time: this.$gettext('The Range Of Time'),
				unlimited: this.$gettext('Unlimited'),
				oneDay: this.$gettext('Within one day'),
				oneMouth: this.$gettext('Within one mouth'),
				sevenDay: this.$gettext('Within seven days'),
				pleaseinput: this.$gettext('Please input'),
				startTime: this.$gettext('Start Time'),
				endTime: this.$gettext('End Time'),
				select: this.$gettext('select'),
				ip: this.$gettext('Source IP'),
				fileTransfer: this.$gettext('File Transfer'),
			}
		},
		// 获取所有成员
		getMemberName() {
			let params = {
				page_size: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.LOG.GET_ACCOUNT_NAME, params).then((res) => {
				this.advanceSearchForm.allMember = res.objects
			})
		},
		// 获取所有资源的名称
		getAllResourceName() {
			let params = {
				results_per_page: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.LOG.GET_RESOURCE_NAME, params).then((res) => {
				this.advanceSearchForm.allResourceName = res.data
			})
		},
		// 成员搜索提示结果
		memberSearch(queryString, cb) {
			let allMember = this.advanceSearchForm.allMember
			let results = queryString ? allMember.filter(this.memberFilter(queryString)) : allMember
			// 调用 callback 返回建议列表的数据
			cb(results)
		},
		memberFilter(queryString) {
			return (restaurant) => {
				return restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
			}
		},
		// 资源名称搜索提示结果
		resourceNameSearch(queryString, cb) {
			let allResourceName = this.advanceSearchForm.allResourceName
			let results = queryString ? allResourceName.filter(this.createFilter(queryString)) : allResourceName
			// 调用 callback 返回建议列表的数据
			cb(results)
		},
		createFilter(queryString) {
			return (restaurant) => {
				return restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0
			}
		},
		// 提交搜索数据
		onSubmitSearch(form) {
			console.log(form, 'form')
			let options = {}
			if (form.resourceType !== '') {
				options.resourceType = form.resourceType
			}
			if (form.keywords !== '') {
				options.keywords = form.keywords
			}
			if (form.member !== '') {
				options.member = form.member
			}
			if (form.ip !== '') {
				options.ip = form.ip
			}
			if (form.resourceName !== '') {
				options.resourceName = form.resourceName
			}
			if (form.unSafeMode) {
				options.unSafeMode = form.unSafeMode
			}
			if ((form.timeType === '1' && form.timeRange !== 'unlimit') || form.timeType === '2') {
				let now = new Date()
				if (form.timeType === '1') {
					if (form.timeRange === 'oneDay') {
						let oneDay = moment(now.getTime() - 24 * 3600 * 1000).format('YYYY-MM-DD')
						options.timeRange = [oneDay, moment().format('YYYY-MM-DD')]
					} else if (form.timeRange === 'sevenDay') {
						let sevenDay = moment(now.getTime() - 7 * 24 * 3600 * 1000).format('YYYY-MM-DD')
						options.timeRange = [sevenDay, moment().format('YYYY-MM-DD')]
					} else if (form.timeRange === 'oneMouth') {
						let oneMouth = moment(now.getTime() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD')
						options.timeRange = [oneMouth, moment().format('YYYY-MM-DD')]
					}
				} else if (form.timeType === '2') {
					if (form.startTime !== '') {
						let startTime = moment(form.startTime.getTime()).format('YYYY-MM-DD')
						if (form.endTime !== '') {
							let endTime = moment(form.endTime.getTime()).format('YYYY-MM-DD')
							options.timeRange = [startTime, endTime]
						} else {
							options.timeRange = [startTime, '']
						}
					} else {
						if (form.endTime !== '') {
							form.timeRange = moment(form.endTime.getTime()).format('YYYY-MM-DD')
						}
					}
				}
			}
			this.$emit('callback', options)
			this.$refs.rightPanel.onClose()
		},
		memberSelect(item) {
			this.advanceSearchForm.member = item.name
		},
		resourceSelect(item) {
			this.advanceSearchForm.resourceName = item
		},
		// 关闭侧滑
		onClose() {
			this.connects = null
			this.$emit('onClosePanel')
		},
		// 重置表单
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.advanceSearchForm.endTime = ''
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
.my-autocomplete {
	li {
		line-height: normal;
		padding: 7px;
		.avatar {
			width: 20px;
			height: 20px;
			border-radius: 50%;
			margin-right: 10px;
		}
		.name {
			display: inline-block;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}
}
.auto-search {
	.el-autocomplete {
		width: 100%;
	}
}
.radio-search {
	margin-top: 20px;
}
.el-radio__label {
	margin-left: 10px;
}
.el-radio + .el-radio {
	margin-left: 0;
	margin-top: 20px;
}
.el-checkbox__label {
	margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// log-search.vue?facbc1c0